import {
  DEPOSIT_AMOUNT,
  MAKE_MIN_DEPOSIT_AMOUNT_REQUIRED,
  PROFIT_SHARING_FIELD,
} from '@components-member/shared/forms/formFields';
import ENUM_CONSTANTS from '@components-shared/enum.constants';
import { IFormField } from '@components-shared/forms/formField.interface';
import { EnumUTACopyTAMasterFormField } from '@components-shared/socialTrading/enums';
import { keyMap } from '@locales/lokalise/keyMap';

export const FIELDS_MASTER: IFormField[] = [
  {
    name: EnumUTACopyTAMasterFormField.accountType,
    title: keyMap.sharedFieldsAccountType,
    type: 'customSelect',
    options: [],
    attributes: { autoComplete: 'off', disabled: true },
    required: true,
  },
  {
    name: EnumUTACopyTAMasterFormField.copyType,
    title: keyMap.tradingAccountsCopyType,
    type: 'customSelect',
    options: ENUM_CONSTANTS.ALLOCATION_METHOD,
    attributes: { autoComplete: 'off', disabled: true },
    required: true,
  },
  {
    name: EnumUTACopyTAMasterFormField.isVisible,
    title: keyMap.commonStatus,
    type: 'customSelect',
    options: [],
    attributes: { autoComplete: 'off' },
    hintMessage: keyMap.settingsMasterAccountSettingsFormMastersVisibilityHint,
    required: true,
  },
  {
    name: EnumUTACopyTAMasterFormField.leverage,
    title: keyMap.commonLeverage,
    type: 'customSelect',
    options: [],
    attributes: { autoComplete: 'off', disabled: true },
    required: true,
  },
  {
    name: EnumUTACopyTAMasterFormField.commissionAccountLogin,
    title: keyMap.copyTradingCommissionAccount,
    type: 'customSelect',
    options: [],
    attributes: { autoComplete: 'off' },
    required: true,
  },
  {
    ...PROFIT_SHARING_FIELD,
    name: EnumUTACopyTAMasterFormField.profitSharing,
  } as IFormField,
  {
    ...DEPOSIT_AMOUNT,
    name: EnumUTACopyTAMasterFormField.recommendedMinDepositAmount,
  } as IFormField,
  MAKE_MIN_DEPOSIT_AMOUNT_REQUIRED,
];
